import { type BaseItem, type NullablePartial } from '../common.js';

export enum Kind {
  AthenaIDX = 'ATHENAIDX',
  AthenaIDXBasic = 'ATHENAIDX_BASIC',
  AthenaOne = 'ATHENAONE',
  EPIC = 'FHIR_EPIC',
  EpicAppMarket = 'EPIC_APP_MARKET',
  FHIRAthenaOne = 'FHIR_ATHENAONE',
  FHIRCerner = 'FHIR_CERNER',
  FHIREClinicalWorks = 'FHIR_ECLINICALWORKS',
  GoogleHealthcare = 'GOOGLE_HEALTHCARE',
  Intergy = 'INTERGY',
  MeditechExpanse = 'MEDITECH_EXPANSE',
  Metriport = 'METRIPORT',
  OnBase = 'ON_BASE',
  VistA = 'VISTA',
  Medplum = 'MEDPLUM',
  Ontada = 'ONTADA',
  AthenaPractice = 'ATHENAPRACTICE',
}

export interface BaseApiInstance {
  authenticationUrl: string;
  baseUrl: string;
  bearerTokenGcsmReferenceId: string | null;
  deploymentName: string;
  clientId: string;
  clientSecretGcsmReferenceId: string | null;
  kind: Kind;
  mrnURI: string | null;
  encounterUrn: string | null;
  practitionerUrn: string | null;
  locationUrn: string | null;
  privateKeyGcsmReferenceId: string | null;
  name: string;
  basicAuthGcsmReferenceId: string | null;
  organizationId: string;
  organizationReferenceId: string | null;
  patientIdType: string | null;
  previousBalancePatientIdType: string | null;
  enableProxy: boolean;
  maxAuthenticationTokens: number | null;
  isTest: boolean;
  authenticationTokenGcsmReferenceId: string | null;
  authenticationTokenExpires: string | null;
  requestsPerMinuteLimit: number | null;
  ehrSystemId: string | null;
  locked: string | null;
}

export interface ApiInstance extends BaseApiInstance, BaseItem {}

export type ApiInstanceBasic = Pick<
  ApiInstance,
  'id' | 'name' | 'kind' | 'organizationId' | 'deploymentName' | 'baseUrl'
>;

export interface FindAllOptions extends Partial<Pick<ApiInstance, 'kind'>> {}
export type CreateValues = NullablePartial<
  Omit<
    BaseApiInstance,
    | 'bearerTokenGcsmReferenceId'
    | 'clientSecretGcsmReferenceId'
    | 'privateKeyGcsmReferenceId'
    | 'basicAuthGcsmReferenceId'
  >
> & {
  bearerToken?: string;
  privateKey?: string;
  clientSecret?: string;
  basicAuth?: string;
};
export type UpdateValues = Partial<BaseApiInstance>;

export interface FindAllOptions {
  authenticationUrl?: string;
  baseUrl?: string;
  deploymentName?: string;
  clientId?: string;
  kind?: Kind;
  organizationId?: string;
}

export interface FindFhirEndpointsOptions {
  scopes?: string[];
  q?: string;
}
